export default function buildGetShopDeals({
    apiEndpoint,
    apiTools
}) {
    return async function getShopDeals(args = {}) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/shop` 
        })
        
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
            'Authorization': 'salaTokken'
            },
            credentials: 'include',
        });
        return await res.json();
    }
}

// "isNotAcceptedCount": 29,
// "isNotShippedCount": 4,
// "isShippedCount": 6,
// "isNotFeedbackGivenCount": 20,
// "isFinalizedCount": 30,
// "isDisputedCount": 14,
// "isCancelledCount": 14